const knowledge_color_group = [
  { key: 1, color: "#C3DBF0" },
  { key: 2, color: "#DEC5F6" },
  { key: 3, color: "#FFAF75" },
  { key: 4, color: "#F6C2C2" },
  { key: 5, color: "#96F1FD" },
  { key: 6, color: "#FFDF5C" },
  { key: 7, color: "#9ACFFF" },
  { key: 8, color: "#C593EF" },
  { key: 9, color: "#FFA012" },
  { key: 10, color: "#F08B8B" },
  { key: 11, color: "#D6B700" },
  { key: 12, color: "#C3DBF0" },
  { key: 13, color: "#DEC5F6" },
  { key: 14, color: "#FFAF75" },
  { key: 15, color: "#F6C2C2" },
  { key: 16, color: "#96F1FD" },
  { key: 17, color: "#FFDF5C" },
  { key: 18, color: "#9ACFFF" },
  { key: 19, color: "#C593EF" },
  { key: 20, color: "#FFA012" },
  { key: 21, color: "#F08B8B" },
  { key: 22, color: "#D6B700" },
  { key: 23, color: "#C3DBF0" },
  { key: 24, color: "#DEC5F6" },
  { key: 25, color: "#FFAF75" },
  { key: 26, color: "#F6C2C2" },
  { key: 27, color: "#96F1FD" },
  { key: 28, color: "#FFDF5C" },
  { key: 29, color: "#9ACFFF" },
  { key: 30, color: "#C593EF" },
  { key: 31, color: "#FFA012" },
  { key: 32, color: "#F08B8B" },
  { key: 33, color: "#D6B700" },
  { key: 34, color: "#C3DBF0" },
  { key: 35, color: "#DEC5F6" },
  { key: 36, color: "#FFAF75" },
  { key: 37, color: "#F6C2C2" },
  { key: 38, color: "#96F1FD" },
  { key: 39, color: "#FFDF5C" },
  { key: 40, color: "#9ACFFF" },
  { key: 41, color: "#C593EF" },
  { key: 42, color: "#FFA012" },
  { key: 43, color: "#F08B8B" },
  { key: 44, color: "#D6B700" },
  { key: 45, color: "#C3DBF0" },
  { key: 46, color: "#DEC5F6" },
  { key: 47, color: "#FFAF75" },
  { key: 48, color: "#F6C2C2" },
  { key: 49, color: "#96F1FD" },
  { key: 50, color: "#FFDF5C" },
  { key: 51, color: "#9ACFFF" },
  { key: 52, color: "#C593EF" },
  { key: 53, color: "#FFA012" },
  { key: 54, color: "#F08B8B" },
  { key: 55, color: "#D6B700" },
  { key: 56, color: "#C3DBF0" },
  { key: 57, color: "#DEC5F6" },
  { key: 58, color: "#FFAF75" },
  { key: 59, color: "#F6C2C2" },
  { key: 60, color: "#96F1FD" },
  { key: 61, color: "#FFDF5C" },
  { key: 62, color: "#9ACFFF" },
  { key: 63, color: "#C593EF" },
  { key: 64, color: "#FFA012" },
  { key: 65, color: "#F08B8B" },
  { key: 66, color: "#D6B700" },
  { key: 67, color: "#C3DBF0" },
  { key: 68, color: "#DEC5F6" },
  { key: 69, color: "#FFAF75" },
  { key: 70, color: "#F6C2C2" },
  { key: 71, color: "#96F1FD" },
  { key: 72, color: "#FFDF5C" },
  { key: 73, color: "#9ACFFF" },
  { key: 74, color: "#C593EF" },
  { key: 75, color: "#FFA012" },
  { key: 76, color: "#F08B8B" },
  { key: 77, color: "#D6B700" },
  { key: 78, color: "#C3DBF0" },
  { key: 79, color: "#DEC5F6" },
  { key: 80, color: "#FFAF75" },
  { key: 81, color: "#F6C2C2" },
  { key: 82, color: "#96F1FD" },
  { key: 83, color: "#FFDF5C" },
  { key: 84, color: "#9ACFFF" },
  { key: 85, color: "#C593EF" },
  { key: 86, color: "#FFA012" },
  { key: 87, color: "#F08B8B" },
  { key: 88, color: "#D6B700" },
  { key: 89, color: "#C3DBF0" },
  { key: 90, color: "#DEC5F6" },
  { key: 91, color: "#FFAF75" },
  { key: 92, color: "#F6C2C2" },
  { key: 93, color: "#96F1FD" },
  { key: 94, color: "#FFDF5C" },
  { key: 95, color: "#9ACFFF" },
  { key: 96, color: "#C593EF" },
  { key: 97, color: "#FFA012" },
  { key: 98, color: "#F08B8B" },
  { key: 99, color: "#D6B700" },
  { key: 100, color: "#C3DBF0" }
];
export default knowledge_color_group;